var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { SiteLogo } from './site-logo';
import { classNames } from '@shapeable/utils';
import { useSite } from '../hooks/use-site';
var cls = classNames('site-header-logo');
export var SiteHeaderLogoDefaultProps = {
  sizeVariant: 'default'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    align-self: center;\n    height: 100%;\n    position: relative;\n\n    ", "\n  \n    flex-shrink: 0;\n    img {\n      height: 100%;\n      object-fit: contain;\n      display: block;\n    }\n\n    transition: filter 0.2s;\n    &:hover {\n      filter: saturate(2);\n    }\n\n  "], ["\n    align-self: center;\n    height: 100%;\n    position: relative;\n\n    ", "\n  \n    flex-shrink: 0;\n    img {\n      height: 100%;\n      object-fit: contain;\n      display: block;\n    }\n\n    transition: filter 0.2s;\n    &:hover {\n      filter: saturate(2);\n    }\n\n  "])), function (_a) {
    var maxHeight = _a.maxHeight,
      horizontalOffset = _a.horizontalOffset,
      verticalOffset = _a.verticalOffset,
      horizontalOffsetMobile = _a.horizontalOffsetMobile,
      verticalOffsetMobile = _a.verticalOffsetMobile,
      heightMobile = _a.heightMobile;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: ", "px;\n      left: ", "px;\n      top: ", "px;\n    "], ["\n      height: ", "px;\n      left: ", "px;\n      top: ", "px;\n    "])), Math.min(maxHeight, heightMobile), horizontalOffsetMobile || horizontalOffset, verticalOffsetMobile || verticalOffset);
  }),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n\n\n  "], ["\n    ", "\n\n\n  "])), function (_a) {
    var maxHeight = _a.maxHeight,
      heightTablet = _a.heightTablet,
      horizontalOffset = _a.horizontalOffset,
      verticalOffset = _a.verticalOffset,
      horizontalOffsetMobile = _a.horizontalOffsetMobile,
      verticalOffsetMobile = _a.verticalOffsetMobile,
      sizeVariant = _a.sizeVariant;
    return sizeVariant === 'default' && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      height: ", "px;\n      left: ", "px;\n      top: ", "px;\n    "], ["\n      height: ", "px;\n      left: ", "px;\n      top: ", "px;\n    "])), Math.min(maxHeight, heightTablet), horizontalOffsetMobile || horizontalOffset, verticalOffsetMobile || verticalOffset);
  }),
  desktop: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var maxHeight = _a.maxHeight,
      heightDesktop = _a.heightDesktop,
      horizontalOffset = _a.horizontalOffset,
      verticalOffset = _a.verticalOffset,
      horizontalOffsetDesktop = _a.horizontalOffsetDesktop,
      verticalOffsetDesktop = _a.verticalOffsetDesktop,
      sizeVariant = _a.sizeVariant;
    return sizeVariant === 'default' && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      height: ", "px;\n      left: ", "px;\n      top: ", "px;\n    "], ["\n      height: ", "px;\n      left: ", "px;\n      top: ", "px;\n    "])), Math.min(maxHeight, heightDesktop), horizontalOffsetDesktop || horizontalOffset, verticalOffsetDesktop || verticalOffset);
  })
});
// -------- Components -------->
var My = {
  Container: styled(SiteLogo)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var SiteHeaderLogo = function (props) {
  var className = props.className,
    isInverted = props.isInverted,
    sizeVariant = props.sizeVariant,
    useVerticalOffsets = props.useVerticalOffsets,
    _a = props.maxHeight,
    maxHeight = _a === void 0 ? 9999 : _a;
  var _b = useSite(),
    logoHorizontalOffset = _b.logoHorizontalOffset,
    logoVerticalOffset = _b.logoVerticalOffset,
    logoHorizontalOffsetMobile = _b.logoHorizontalOffsetMobile,
    logoVerticalOffsetMobile = _b.logoVerticalOffsetMobile,
    logoHorizontalOffsetTablet = _b.logoHorizontalOffsetTablet,
    logoVerticalOffsetTablet = _b.logoVerticalOffsetTablet,
    logoHorizontalOffsetDesktop = _b.logoHorizontalOffsetDesktop,
    logoVerticalOffsetDesktop = _b.logoVerticalOffsetDesktop,
    logoHeightDesktop = _b.logoHeightDesktop,
    logoHeightMobile = _b.logoHeightMobile,
    logoHeightTablet = _b.logoHeightTablet;
  var logoProps = {
    heightDesktop: logoHeightDesktop,
    heightTablet: logoHeightTablet,
    heightMobile: logoHeightMobile,
    verticalOffset: useVerticalOffsets ? logoVerticalOffset : 0,
    horizontalOffset: logoHorizontalOffset,
    verticalOffsetMobile: useVerticalOffsets ? logoVerticalOffsetMobile : 0,
    horizontalOffsetMobile: logoHorizontalOffsetMobile,
    verticalOffsetTablet: useVerticalOffsets ? logoVerticalOffsetTablet : 0,
    horizontalOffsetTablet: logoHorizontalOffsetTablet,
    verticalOffsetDesktop: useVerticalOffsets ? logoVerticalOffsetDesktop : 0,
    horizontalOffsetDesktop: logoHorizontalOffsetDesktop,
    variant: isInverted ? 'inverted' : 'default',
    maxHeight: maxHeight
  };
  return React.createElement(My.Container, __assign({
    sizeVariant: sizeVariant
  }, logoProps, {
    className: cls.name(className)
  }));
};
SiteHeaderLogo.cls = cls;
SiteHeaderLogo.defaultProps = SiteHeaderLogoDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;